module.exports = __webpack_public_path__ + "19ce776eedd5472cafa0928dc6512b54.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/service-icon-nbn.png
// module id = 658
// module chunks = 1